<template>
  <div class="es-error-page h-full eui-u-bg-white">
    <EuiGrid class="h-full">
      <EuiGridRow class="eui-u-h-screen">
        <EuiGridColumn width="1/2" class="flex-col eui-u-justify-center h-full es-error-page__infos">
          <img class="es-error-page__logo eui-u-mb-8" src="/logo_blue.svg" alt="logo eDocSign"/>
          <div class="es-error-page__content">
            <h1 v-if="errorCode !== '0'" class="es-error-page__error-label">
              {{ $t(`errors.accessToken.renew.${errorCode}`) }}
            </h1>
            <h1 v-else class="es-error-page__error-label">
              {{ $t(`errors.unknow`) }}
            </h1>
            <EuiButton class="eui-u-mt-8 eui-u-w-fit-content" v-if="errorCode === '001'" variant="raised" color="primary" @click.prevent="renewAccessToken()">
              {{ $t('accessToken.renew.button') }}
            </EuiButton>
          </div>
        </EuiGridColumn>
        <EuiGridColumn class="flex-col flex-align-center eui-u-justify-center h-full">
          <img class="es-error-page__visual" src="./svg/erreur.svg" alt="image d'illustration pour l'indisponibilité"/>
        </EuiGridColumn>
      </EuiGridRow>
    </EuiGrid>
  </div>
</template>

<script>

import {mapActions} from 'vuex';

export default {
  name: 'error.vue',
  props: {
    stepUuid: {
      type: String,
      required: false,
      default: undefined,
    },
    errorCode: {
      type: String,
      required: false,
      default: undefined,
    },
  },
  methods: {
    ...mapActions({
      renewToken: 'ModuleEdocSign/auth/renewToken',
    }),
    renewAccessToken() {
      this.renewToken({ uuid: this.stepUuid }).then(() => {
        this.tokenGenerated = true;
      });
    },
  },
};
</script>

<style scoped lang="scss">
  .es-error-page {

    &__logo {
      width: 150px;
      margin-left: 20%;
    }

    &__content {
      margin-left: 20%;
      display: flex;
      flex-direction: column;
    }

    &__error-reason {
      font-size: 32px;
      letter-spacing: 3px;
    }

    &__error-label {
      font-size: 56px;
      margin: 10px 0;
      font-weight: 400;
      line-height: 64px;
    }

    &__desc {
      font-size: 24px;
    }

    &__info {
      font-size: 16px;
    }

    &__visual {
      width: 300px;
    }
  }
</style>
